import { Grid, GridCol, GridRow } from '@naf/grid';
import { breakpoints, spacing } from '@naf/theme';
import { nafColor } from '@nafcore/theme';
import styled from '@emotion/styled';
import { css } from '@emotion/react';
import { isNotTransientProp } from '../../lib/shouldForwardProp';

export const Wrapper = styled.div<{ $isInModal?: boolean }>`
  position: relative;
  max-width: 1120px;
  padding-top: ${spacing.space32};
  margin: auto;

  ${({ $isInModal }) =>
    $isInModal &&
    css`
      max-width: none;
      padding-top: 0;
    `}
`;

export const CloseButton = styled.button`
  position: absolute;
  top: 0;
  right: 0;
  z-index: 1;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: ${spacing.space48};
  height: ${spacing.space48};
  padding: 0;
  border: none;
  background: transparent;
  cursor: pointer;
  color: ${nafColor.signature.black} !important;
`;

export const SearchWord = styled.span`
  font-weight: 700;
`;

export const AnchorGridCol = styled(GridCol)`
  text-align: right;

  @media (max-width: ${breakpoints.m}) {
    text-align: left;
  }

  nav {
    margin: ${spacing.space16} 0;
  }
`;

export const BottomGridRow = styled(GridRow, { shouldForwardProp: isNotTransientProp })<{ $isInModal?: boolean }>`
  margin-top: -${spacing.space48};

  ${({ $isInModal }) =>
    $isInModal &&
    css`
      margin-top: 0;
    `}

  @media (max-width: ${breakpoints.m}) {
    margin-top: 0;
  }
`;

export const StyledGrid = styled(Grid)`
  min-height: 100%;
  grid-gap: 0;

  p {
    color: ${nafColor.signature.black} !important;
  }

  h2 {
    color: ${nafColor.signature.black} !important;
  }

  @media (max-width: ${breakpoints.m}) {
    grid-gap: 0;
    align-items: flex-start;
  }
`;

export const ShowMoreButtonWrapper = styled.div`
  display: flex;
  align-items: center;

  button {
    margin-right: 20px;
  }
`;

export const AnchorLinks = styled.nav`
  margin: ${spacing.space32} 0;
`;

export const ResultGridCol = styled(GridCol, { shouldForwardProp: isNotTransientProp })<{ $isInModal?: boolean }>`
  grid-column-start: 4;

  ${({ $isInModal }) =>
    $isInModal &&
    css`
      grid-column-start: 1;
    `}

  p {
    color: ${nafColor.signature.black} !important;
  }

  a:hover {
    text-decoration: none;
  }

  @media (max-width: ${breakpoints.l}) {
    grid-column-start: 1;
  }
`;

export const ShowMoreGridCol = styled(GridCol, { shouldForwardProp: isNotTransientProp })<{ $isInModal?: boolean }>`
  grid-column-start: 4;

  ${({ $isInModal }) =>
    $isInModal &&
    css`
      grid-column-start: 1;
    `}

  p {
    color: ${nafColor.signature.black} !important;
  }

  a:hover {
    text-decoration: none;
  }

  @media (max-width: ${breakpoints.l}) {
    grid-column-start: 1;
  }
`;

export const ResultWrapper = styled.ul`
  list-style: none;
  padding: 0;
  margin-bottom: 0;

  > li:first-child a > div {
    padding-top: 0;
  }
`;

export const ErrorWrapper = styled.div`
  text-align: center;
  padding-top: ${spacing.space48};
  padding-bottom: ${spacing.space64};

  p {
    margin-top: ${spacing.space8};
  }

  h2 {
    margin-bottom: ${spacing.space8};
  }

  div {
    margin: 0 auto;
  }
`;

export const NoResultGridCol = styled(GridCol)`
  margin-top: ${spacing.space16};
`;
